/*
  Feedback page API
*/
import { convertToSnakeCase } from 'data_system/helpers/apiHelpers.js';

import axios from 'axios';
// CSRF Token
const authenticityToken = document.getElementsByName('csrf-token')[0].content;
const headers = {
  'X-CSRF-Token': authenticityToken,
  'X-Requested-With': 'XMLHttpRequest',
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

const Api = {
  updateFeedback(id, formData) {
    const data = { ...formData };
    convertToSnakeCase(data);
    return axios({
      headers,
      method: 'patch',
      url: `/tya/feedback/${id}`,
      data,
    });
  },
};

export default Api;
